import { useQuery } from "react-query";
import { getAllSafeMake } from "../../../../../actions/Utilities/SafeMake";

export default function useGetSafeMake() {
  return useQuery("GetSafeMake", getAllSafeMake, {
    refetchOnWindowFocus: false,
  });
}
